import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@y42/environment';
import { ErrorHandlerService } from '@y42/error-handling';
import { ACTIVE_USER_ID_API_URL_PARAM } from '@y42/model';
import { Observable, ObservableInput, ObservedValueOf, OperatorFunction, throwError } from 'rxjs';
import { TwoFactorCodeRequestHttpModel, TwoFactorModel } from '../models/two-factor.model';
import { BaseErrorResponseHttpModel } from './two-factor.model';

@Injectable({ providedIn: 'root' })
export class TwoFactorHttpService {
  constructor(private readonly httpService: HttpClient, private readonly errorHandlerService: ErrorHandlerService) {}

  enable(code: string): Observable<void> {
    const request: TwoFactorCodeRequestHttpModel = {
      code,
    };
    return this.httpService.post<void>(this.getUrl(), request);
  }

  disable(code: string): Observable<void> {
    const request: TwoFactorCodeRequestHttpModel = {
      code,
    };
    return this.httpService
      .put<void>(this.getUrl(), request)
      .pipe(this.catchErrorAndThrow('[TwoFactorHttpService.disable]: could not disable 2fa'));
  }

  getState(userId: number): Observable<TwoFactorModel> {
    return this.httpService.get<TwoFactorModel>(this.getUrl(userId));
  }

  private getUrl(userId?: number): string {
    return `${environment.url.identity_api}/user/${userId || ACTIVE_USER_ID_API_URL_PARAM}/2fa`;
  }

  private catchErrorAndThrow<T, O extends ObservableInput<never>>(
    message: string,
  ): OperatorFunction<T, T | ObservedValueOf<O>> {
    return this.errorHandlerService.catchError(message, (error: unknown) =>
      throwError(() => {
        if (error instanceof HttpErrorResponse) {
          return new Error((error.error as BaseErrorResponseHttpModel)?.message || '');
        }
        return error;
      }),
    );
  }
}
